export default "/_next/static/assets/images/sprite.c62dcaa84c906eb7118c8c762f311dae.svg";